/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/min.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'The minimum value of a field.',
  examples: [
    'FROM employees\n| STATS MIN(languages)',
    'FROM employees\n| STATS min_avg_salary_change = MIN(MV_AVG(salary_change))',
    'TS exp_histo_sample\n| WHERE instance == "instance-0"\n| STATS minimum = ROUND(MIN(responseTime), 4)',
    'TS histogram_timeseries_index\n| WHERE instance == "instance-0"\n| STATS minimum = ROUND(MIN(responseTime::tdigest), 4)',
  ],
  params: {
    field: '',
  },
};

export default docs;
